import {httpClient} from '@/main';
import {Localization, Status} from '@/models/AppModel';
import {getRefreshToken} from '@/utils';
import {DemoForm, LoginForm, LoginSuccess} from '@/models/LoginModel';

export const fetchLocalization = () => httpClient.get<Localization>('localization/getLocalization');
export const changeLanguage = (culture: string) =>
    httpClient.post<Localization>('localization/setCulture', null, {
        params: {
            culture,
        },
    });
export const fetchStatus = () => httpClient.get<Status>('login/getStatus');
export const changeCompany = (idCompany: number) =>
    httpClient.post('login/changeCompany', null, {
        params: {
            idCompany,
        },
    });
export const login = ({userName, password, rememberMe}: LoginForm) =>
    httpClient.post<LoginSuccess>('login/login', {
        userName,
        password,
        rememberMe,
    });
export const logout = () =>
    httpClient.get('login/logout', {
        params: {
            refreshToken: getRefreshToken(),
        },
    });
export const refresh = () =>
    httpClient.get<string>('login/refresh', {
        params: {
            refreshToken: getRefreshToken(),
        },
    });
export const requestDemo = (form: DemoForm) =>
    httpClient.post('login/customerRequestDemo', {
        ...form,
    });
